import { render, staticRenderFns } from "./VueCard.vue?vue&type=template&id=6fe0de10&"
import script from "./VueCard.vue?vue&type=script&lang=js&"
export * from "./VueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports